import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reelsList: [],
  reelsFormList: [],
  reelsStatisticList: [],
  reelsDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const reelsSlice = createSlice({
  name: "reels",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
      state.loading = false;
      state.success = false;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchReelsList(state, action) {
      state.reelsList = action.payload;
      state.loading = false;
    },
    fetchReelsFormList(state, action) {
      state.reelsFormList = action.payload;
      state.loading = false;
    },
    fetchReelsStatisticList(state, action) {
      state.reelsStatisticList = action.payload;
      state.loading = false;
    },
    fetchReelsDetail(state, action) {
      state.reelsDetail = action.payload;
      state.loading = false;
    },
  },
});

export const reelsActions = reelsSlice.actions;

export default reelsSlice.reducer;
